var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.4 25",
    style: {
      enableBackground: "new 0 0 37.4 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.4,0H3.9C1.8,0,0,1.8,0,3.9v17.1C0,23.2,1.8,25,3.9,25h29.5c2.2,0,3.9-1.8,3.9-3.9V3.9 C37.4,1.8,35.6,0,33.4,0z M31.8,3l-12.3,9.8c-0.5,0.4-1.1,0.4-1.5,0L5.6,3H31.8z M33.4,22H3.9C3.4,22,3,21.6,3,21.1V4.8l6.4,5.1 l6.6,5.3c0.8,0.6,1.7,0.9,2.6,0.9s1.9-0.3,2.6-0.9L34.4,4.8v16.3C34.4,21.6,34,22,33.4,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d0c88d084296a88744f0afaf99c60685.svg";
export { ForwardRef as ReactComponent };